import React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Stack from "@mui/material/Stack";
import { FilterMode } from "./types";
import { FILTER_MODE } from "./constants";

interface ConditionToggleFilterProps {
  value: FilterMode | undefined;
  onChange: (value: FilterMode) => void;
  label?: string;
  id?: string;
}

export const ConditionToggleFilter: React.FC<ConditionToggleFilterProps> = ({
  value,
  onChange,
  id = "condition-toggle-filter",
}) => {
  const handleChange = (
    _: React.MouseEvent<HTMLElement>,
    newValue: FilterMode | null
  ) => {
    if (!newValue) return;

    onChange(newValue);
  };

  return (
    <Stack direction="column" spacing={1} id={id}>
      <ToggleButtonGroup
        id={`${id}-group`}
        value={value}
        exclusive
        onChange={handleChange}
        size="small"
        color="secondary"
        fullWidth
      >
        <ToggleButton id={`${id}-any-btn`} value={FILTER_MODE.ANY}>
          ANY
        </ToggleButton>
        <ToggleButton id={`${id}-all-btn`} value={FILTER_MODE.ALL}>
          ALL
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};
